package com.karyadina.service

import kotlinx.browser.localStorage
import org.w3c.dom.get
import org.w3c.dom.set

/**
 * Web implementation using localStorage for persistent storage
 * Data survives browser sessions
 */
class WebKeyValueStorage : KeyValueStorage {
    
    override fun saveString(key: String, value: String) {
        localStorage[key] = value
    }
    
    override fun loadString(key: String): String? {
        return localStorage[key]
    }
    
    override fun saveInt(key: String, value: Int) {
        localStorage[key] = value.toString()
    }
    
    override fun loadInt(key: String, defaultValue: Int): Int {
        return localStorage[key]?.toIntOrNull() ?: defaultValue
    }
    
    override fun saveBoolean(key: String, value: Boolean) {
        localStorage[key] = value.toString()
    }
    
    override fun loadBoolean(key: String, defaultValue: Boolean): Boolean {
        return localStorage[key]?.toBooleanStrictOrNull() ?: defaultValue
    }
    
    override fun remove(key: String) {
        localStorage.removeItem(key)
    }
    
    override fun clear() {
        localStorage.clear()
    }
    
    override fun contains(key: String): Boolean {
        return localStorage[key] != null
    }
    
    override fun exportAll(): Map<String, String> {
        val result = mutableMapOf<String, String>()
        for (i in 0 until localStorage.length) {
            val key = localStorage.key(i)
            if (key != null) {
                val value = localStorage[key]
                if (value != null) {
                    result[key] = value
                }
            }
        }
        return result
    }
    
    override fun importAll(data: Map<String, String>) {
        for ((k, v) in data) {
            localStorage[k] = v
        }
    }
}
